export function getNameInitials(firstName = '', lastName = ''): string {
    return firstName?.charAt(0)?.toUpperCase() + lastName?.charAt(0)?.toUpperCase();
}

export function cleanHTML(htmlString: string) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString.replace(/target="_blank"/g, '');
    tempDiv.querySelectorAll('a').forEach((link) => {
        link.setAttribute('target', '_blank');
    });

    return tempDiv.innerHTML;
}
